/**
 * Create an HTMLImageElement from a URL (data URL or http).
 * Required for canvas drawImage.
 */
function createImage(url) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.addEventListener('load', () => resolve(image));
        image.addEventListener('error', (err) => reject(err));
        image.src = url;
    });
}

/**
 * Crop image by pixel area and return as base64 data URL.
 * @param {string} imageSrc - Data URL or image URL
 * @param {Object} pixelCrop - { x, y, width, height } from react-easy-crop
 * @returns {Promise<string>} Base64 data URL of cropped image (JPEG)
 */
export async function getCroppedImg(imageSrc, pixelCrop) {
    if (!imageSrc || !pixelCrop || pixelCrop.width <= 0 || pixelCrop.height <= 0) {
        throw new Error('Invalid image or crop area');
    }

    const image = await createImage(imageSrc);

    const x = Math.round(pixelCrop.x);
    const y = Math.round(pixelCrop.y);
    const width = Math.round(pixelCrop.width);
    const height = Math.round(pixelCrop.height);

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');

    if (!ctx) {
        throw new Error('Canvas 2d context not available');
    }

    ctx.drawImage(
        image,
        x, y, width, height,  // source rect
        0, 0, width, height   // destination rect
    );

    return canvas.toDataURL('image/jpeg', 0.92);
}
